import { AdminDetailContainer } from "../../containers/borrowSystem/AdminDetailContainer";

export function AdminDetailPage() {
    return (
        <AdminDetailContainer />
    )
}
